import { createAction, props } from '@ngrx/store';
import {
  CreateOrUpdateSystemIntegrationLoginRequest,
  SystemIntegrationLogin,
  SystemIntegrationLoginPassword,
} from 'brain-data/model/system-integration-login.model';
import {
  CreateOrUpdateSystemIntegrationContactRequest,
  SystemIntegrationContact,
} from 'brain-data/model/system-integration-contact.model';

export const loadSystemIntegrationLogins = createAction('[System Integration] Load Logins');

export const loadSystemIntegrationLoginsSuccess = createAction(
  '[System Integration] Load Logins Success',
  props<{ logins: SystemIntegrationLogin[] }>(),
);

export const loadSystemIntegrationLoginsError = createAction(
  '[System Integration] Load Logins Error',
  props<{ error: any }>(),
);

export const createSystemIntegrationLogin = createAction(
  '[System Integration] Create Login',
  props<{ payload: CreateOrUpdateSystemIntegrationLoginRequest }>(),
);

export const createSystemIntegrationLoginSuccess = createAction(
  '[System Integration] Create Login Success',
  props<{ login: SystemIntegrationLogin }>(),
);

export const createSystemIntegrationLoginError = createAction(
  '[System Integration] Create Login Error',
  props<{ error: any }>(),
);

export const updateSystemIntegrationLogin = createAction(
  '[System Integration] Update Login',
  props<{ id: number; payload: CreateOrUpdateSystemIntegrationLoginRequest }>(),
);

export const updateSystemIntegrationLoginSuccess = createAction(
  '[System Integration] Update Login Success',
  props<{ login: SystemIntegrationLogin }>(),
);

export const updateSystemIntegrationLoginError = createAction(
  '[System Integration] Update Login Error',
  props<{ error: any }>(),
);

export const deleteSystemIntegrationLogin = createAction(
  '[System Integration] Delete Login',
  props<{ id: number }>(),
);

export const deleteSystemIntegrationLoginSuccess = createAction(
  '[System Integration] Delete Login Success',
  props<{ id: number }>(),
);

export const deleteSystemIntegrationLoginError = createAction(
  '[System Integration] Delete Login Error',
  props<{ error: any }>(),
);

export const loadSystemIntegrationLoginPassword = createAction(
  '[System Integration] Load Login Password',
  props<{ id: number }>(),
);

export const loadSystemIntegrationLoginPasswordSuccess = createAction(
  '[System Integration] Load Login Password Success',
  props<{ id: number; password: SystemIntegrationLoginPassword }>(),
);

export const loadSystemIntegrationLoginPasswordError = createAction(
  '[System Integration] Load Login Password Error',
  props<{ error: any }>(),
);

export const loadSystemIntegrationContacts = createAction(
  '[System Integration] Load Contacts',
  props<{ loginId: number }>(),
);

export const loadSystemIntegrationContactsSuccess = createAction(
  '[System Integration] Load Contacts Success',
  props<{ loginId: number; contacts: SystemIntegrationContact[] }>(),
);

export const loadSystemIntegrationContactsError = createAction(
  '[System Integration] Load Contacts Error',
  props<{ loginId: number; error: any }>(),
);

export const createSystemIntegrationContact = createAction(
  '[System Integration] Create Contact',
  props<{ loginId: number; payload: CreateOrUpdateSystemIntegrationContactRequest }>(),
);

export const createSystemIntegrationContactSuccess = createAction(
  '[System Integration] Create Contact Success',
  props<{ loginId: number; contact: SystemIntegrationContact }>(),
);

export const createSystemIntegrationContactError = createAction(
  '[System Integration] Create Contact Error',
  props<{ loginId: number; error: any }>(),
);

export const updateSystemIntegrationContact = createAction(
  '[System Integration] Update Contact',
  props<{ loginId: number; id: number; payload: CreateOrUpdateSystemIntegrationContactRequest }>(),
);

export const updateSystemIntegrationContactSuccess = createAction(
  '[System Integration] Update Contact Success',
  props<{ loginId: number; contact: SystemIntegrationContact }>(),
);

export const updateSystemIntegrationContactError = createAction(
  '[System Integration] Update Contact Error',
  props<{ loginId: number; error: any }>(),
);

export const deleteSystemIntegrationContact = createAction(
  '[System Integration] Delete Contact',
  props<{ loginId: number; id: number }>(),
);

export const deleteSystemIntegrationContactSuccess = createAction(
  '[System Integration] Delete Contact Success',
  props<{ loginId: number; id: number }>(),
);

export const deleteSystemIntegrationContactError = createAction(
  '[System Integration] Delete Contact Error',
  props<{ loginId: number; error: any }>(),
);
